import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper
} from '@material-ui/core'
import { Close } from '@material-ui/icons'
import moment from 'moment'
import Draggable from 'react-draggable'
import numeral from 'numeral'

import classes from './TransactionSubmitValidation.module.scss'

function PaperComponent(props) {
  return (
    <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  )
}

export default function TransactionSubmitValidation(props) {
  const { openDialog, title, close, rawData, type, setLoading, setSubmitDisable, headers = [] } = props
  const handleOnClose = () => {
    setLoading(false)
    close()
  }
  return (
    <Dialog
      fullWidth
      // maxWidth='xs'
      aria-labelledby='customized-dialog-title'
      onClose={close}
      aria-labelledby='customized-dialog-title'
      open={openDialog}
      className={classes.successroot}
      PaperComponent={PaperComponent}
      PaperProps={{ style: { display: 'flex' } }}
    >
      <DialogTitle id="draggable-dialog-title" disableTypography className={classes['header-container']}>
        <div className={classes.header}>
          <Typography className={classes['title']}>
            Error upon Creation!
          </Typography>
          <IconButton
            aria-label='close'
            id='success-close-button'
            className={classes['close-button']}
            onClick={() => handleOnClose()}
          >
            <Close />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Table className={classes.table} stickyHeader>
          <TableHead>
            <TableRow>
              {headers.map((item, index) => (
                <TableCell className={classes.headers}>{item}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {title === 'Non Po Items' ? (
              <>
                {rawData.map((item, index) => (
                  <TableRow>
                    <TableCell className={classes.value}>
                      {item.page}
                    </TableCell>
                    <TableCell className={classes.value} style={{ color: item.glCategory ? 'black' : 'red' }}>
                      {item.glCategory ? item.glCategory : 'required!'}
                    </TableCell>
                    <TableCell className={classes.value} style={{ color: item.glAccount ? 'black' : 'red' }}>
                      {item.glAccount ? item.glAccount : 'required!'}
                    </TableCell>
                    <TableCell className={classes.value} style={{ color: item.description1 ? 'black' : 'red' }}>
                      {item.description1 ? item.description1 : 'required!'}
                    </TableCell>
                    <TableCell className={classes.value} style={{ color: item.grossPricePerItem ? 'black' : 'red' }}>
                      {item.grossPricePerItem >= 1 ? numeral(item.grossPricePerItem).format('0,0.00') : 'must be 1 above!'}
                    </TableCell>
                    {/* {type === 'advances' && (
                      <TableCell className={classes.value} style={{ color: item.projectClass ? 'black' : 'red' }}>
                        {item.projectClass ? item.projectClass : 'required!'}
                      </TableCell>
                    )} */}
                  </TableRow>
                ))}
              </>
            ) : (
              <>
                {rawData.map((item, index) => (
                  <TableRow>
                    <TableCell className={classes.value}>
                      {item.page}
                    </TableCell>
                    <TableCell className={classes.value} style={{ color: item.glCategory ? 'black' : 'red' }}>
                      {item.glCategory ? item.glCategory : 'required!'}
                    </TableCell>
                    <TableCell className={classes.value} style={{ color: item.glAccount ? 'black' : 'red' }}>
                      {item.glAccount ? item.glAccount : 'required!'}
                    </TableCell>
                    <TableCell className={classes.value} style={{ color: item.itemNumber ? 'black' : 'red' }}>
                      {item.itemNumber ? item.itemNumber : 'required!'}
                    </TableCell>
                    <TableCell className={classes.value} style={{ color: item.description1 ? 'black' : 'red' }}>
                      {item.description1 ? item.description1 : 'required!'}
                    </TableCell>
                    <TableCell className={classes.value} style={{ color: item.grossPricePerItem ? 'black' : 'red' }}>
                      {item.grossPricePerItem >= 1 ? numeral(item.grossPricePerItem).format('0,0.00') : 'must be 1 above!'}
                    </TableCell>
                    {type === 'advances' && (
                      <TableCell className={classes.value} style={{ color: item.projectClass ? 'black' : 'red' }}>
                        {item.projectClass ? item.projectClass : 'required!'}
                      </TableCell>
                    )}
                  </TableRow>
                ))}
              </>
            )}
          </TableBody>
        </Table>
        <div className={classes.button}>
          <Button
            variant='contained'
            className={classes['button-positive']}
            onClick={() => {
              setLoading(false)
              close(false)
              setSubmitDisable(false)
            }}
          >
            OK
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
